<script>
	const _ = require('../../assets/js/_');

	component.exports = {
		data () {
			return {};
		},
		oninit () {
			if (!Ractive.isServer && !this.get('@shared.tuText')) {
				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Terms%20of%20Use.md', rawResponse: true }).then((response) => {
					this.set('@shared.tuText', response);
				}).catch(() => {
					this.set('@shared.tuText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Terms%20of%20Use.md`);
				});

				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Privacy%20Policy.md', rawResponse: true }).then((response) => {
					this.set('@shared.ppText', response);
				}).catch(() => {
					this.set('@shared.ppText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Privacy%20Policy.md`);
				});

				_.makeHTTPRequest({ url: 'https://raw.githubusercontent.com/jsdelivr/globalping/master/docs/terms/Cookie%20Policy.md', rawResponse: true }).then((response) => {
					this.set('@shared.cpText', response);
				}).catch(() => {
					this.set('@shared.cpText', `Failed to load the document. Please view it directly at:<br>https://github.com/jsdelivr/globalping/blob/master/docs/terms/Cookie%20Policy.md`);
				});
			}
		},
	};
</script>
